<p [innerHTML]="getContent()"></p>
